import { useLocation } from "react-router-dom";
import { BRAND, whatsappContext } from "@/lib/brand";
import { Phone } from "lucide-react";

// WhatsApp glyph — brand-consistent SVG (not the green Meta logo, which would
// clash with THE KC INDIA gold-black palette).
const WhatsAppGlyph = ({ size = 18 }) => (
  <svg width={size} height={size} viewBox="0 0 24 24" fill="currentColor" aria-hidden="true">
    <path d="M20.5 3.5A11.6 11.6 0 0012.1 0a11.7 11.7 0 00-10 17.8L0 24l6.4-2A11.7 11.7 0 0023.8 12a11.6 11.6 0 00-3.3-8.5zM12.1 21.9a9.8 9.8 0 01-5-1.4l-.4-.2-3.8 1 1-3.7-.2-.4a9.7 9.7 0 1117.5-5.6 9.7 9.7 0 01-9.1 10.3zm5.6-7.3c-.3-.2-1.8-.9-2.1-1s-.5-.2-.7.2-.8 1-1 1.2-.4.2-.7 0a8 8 0 01-2.3-1.4 8.6 8.6 0 01-1.6-2c-.2-.3 0-.5.1-.7l.5-.5.3-.5c.1-.2 0-.4 0-.5s-.7-1.7-1-2.3-.5-.5-.7-.5H8c-.2 0-.5.1-.8.4a3 3 0 00-1 2.2c0 1.3 1 2.6 1.1 2.8s2 3.2 5 4.5c.7.3 1.2.5 1.6.6.7.2 1.3.2 1.8.1.5-.1 1.8-.7 2-1.5s.3-1.4.2-1.5-.3-.2-.5-.3z"/>
  </svg>
);

export const StickyActions = () => {
  const { pathname } = useLocation();
  const ctx = whatsappContext(pathname);

  return (
    <div className="fixed left-3 md:left-5 bottom-3 md:bottom-5 z-40 flex flex-col gap-2 md:gap-2.5" data-testid="sticky-actions">
      {/* WhatsApp — elegant pill that expands with contextual label */}
      <a
        href={ctx.href}
        target="_blank"
        rel="noreferrer"
        aria-label={ctx.label}
        title={ctx.label}
        data-testid="sticky-whatsapp"
        data-context={ctx.label}
        className="group inline-flex items-center bg-[#0F0F0F] border border-[#D4AF37]/50 text-[#D4AF37] hover:bg-[#D4AF37] hover:text-[#0F0F0F] transition-all duration-300 overflow-hidden shadow-lg shadow-black/40 h-11 md:h-12"
      >
        <span className="w-11 h-11 md:w-12 md:h-12 flex-shrink-0 flex items-center justify-center">
          <WhatsAppGlyph size={18} />
        </span>
        <span className="hidden md:inline-block whitespace-nowrap text-[10px] uppercase tracking-[0.24em] pr-0 group-hover:pr-5 max-w-0 group-hover:max-w-[280px] overflow-hidden transition-all duration-500 ease-out">
          {ctx.label}
        </span>
      </a>

      {/* Call — always visible, matches the same visual language */}
      <a
        href={`tel:${BRAND.phone.replace(/\s/g, "")}`}
        aria-label="Call THE KC INDIA"
        title={`Call ${BRAND.phone}`}
        data-testid="sticky-call"
        className="w-11 h-11 md:w-12 md:h-12 flex items-center justify-center bg-[#0F0F0F] border border-[#D4AF37]/50 text-[#D4AF37] hover:bg-[#D4AF37] hover:text-[#0F0F0F] transition-colors shadow-lg shadow-black/40"
      >
        <Phone size={17} strokeWidth={1.6} />
      </a>
    </div>
  );
};
